import { Quill } from 'react-quill';
const Block = Quill.import('blots/block');

class CustomBlockQuote extends Block {
  static create(value: any) {
    const node = super.create();
    node.classList.add('ql-custom-blockquote');
    node.setAttribute('data-custom', value);
    return node;
  }

  static formats() {
    return true;
  }

  format(name: string, value: any) {
    if (name === 'custom-blockquote' && value) {
      this.domNode.setAttribute('data-custom', value);
    } else {
      super.format(name, value);
    }
  }

  static value(node: any) {
    return node.getAttribute('data-custom');
  }
}

CustomBlockQuote.blotName = 'custom-blockquote';
CustomBlockQuote.tagName = 'blockquote';

Quill.register(CustomBlockQuote);
